import { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';

/**
 * Anmelden und Registrieren auf einer Seite.
 *
 * Nach dem Anmelden geht es dorthin zurück, wo man herkam — meist "Meine
 * Pokémon", weil das der einzige Bereich ist, der ein Konto braucht.
 */
export default function AccountPage() {
  const [params] = useSearchParams();
  const [modus, setModus] = useState(params.get('neu') ? 'register' : 'login');
  const navigate = useNavigate();
  const { login, register } = useAuth();

  const ziel = params.get('weiter') || '/mein-bereich';

  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [name, setName] = useState('');
  const [fehler, setFehler] = useState(null);
  const [busy, setBusy] = useState(false);

  const absenden = async () => {
    setBusy(true);
    setFehler(null);
    try {
      if (modus === 'login') {
        await login(email, passwort);
      } else {
        await register(email, passwort, name);
      }
      navigate(ziel, { replace: true });
    } catch (e) {
      setFehler(e.message);
    } finally {
      setBusy(false);
    }
  };

  const bereit = email && passwort && (modus === 'login' || name);

  return (
    <div className="panel" style={{ maxWidth: 440, margin: '32px auto' }}>
      <div className="filters" style={{ marginTop: 0 }}>
        <button
          type="button"
          className={`chip${modus === 'login' ? ' chip--on' : ''}`}
          onClick={() => { setModus('login'); setFehler(null); }}
        >
          Anmelden
        </button>
        <button
          type="button"
          className={`chip${modus === 'register' ? ' chip--on' : ''}`}
          onClick={() => { setModus('register'); setFehler(null); }}
        >
          Neu registrieren
        </button>
      </div>

      {modus === 'register' && (
        <div className="field">
          <label className="field__label" htmlFor="name">Anzeigename</label>
          <input
            id="name" className="input" value={name} maxLength={60}
            onChange={(e) => setName(e.target.value)} autoComplete="nickname"
          />
        </div>
      )}

      <div className="field">
        <label className="field__label" htmlFor="email">E-Mail</label>
        <input
          id="email" className="input" type="email" value={email}
          onChange={(e) => setEmail(e.target.value)} autoComplete="email"
        />
      </div>

      <div className="field">
        <label className="field__label" htmlFor="pw">Passwort</label>
        <input
          id="pw" className="input" type="password" value={passwort}
          onChange={(e) => setPasswort(e.target.value)}
          autoComplete={modus === 'login' ? 'current-password' : 'new-password'}
          onKeyDown={(e) => e.key === 'Enter' && bereit && absenden()}
        />
        {modus === 'register' && (
          <span className="text-faint" style={{ fontSize: '.8rem' }}>
            Mindestens 10 Zeichen.
          </span>
        )}
      </div>

      {fehler && <div className="error" style={{ marginBottom: 16 }}>{fehler}</div>}

      <button className="btn btn--primary" onClick={absenden} disabled={busy || !bereit}>
        {busy ? 'Moment…' : modus === 'login' ? 'Anmelden' : 'Konto anlegen'}
      </button>

      {modus === 'login' && (
        <p style={{ marginTop: 16 }}>
          <Link to="/passwort-vergessen" className="nav__link" style={{ paddingLeft: 0 }}>
            Passwort vergessen?
          </Link>
        </p>
      )}

      <p className="hinweis">
        Ein Konto brauchst du nur für deine eigene Sammlung. Events, Raids und
        Bewertungen sind ohne Anmeldung zugänglich.
      </p>
    </div>
  );
}
